<template>
  <v-container>
    <h4
      :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'headline']"
      class="text-center font-weight-bold"
    >
      Active Listing<span class="font-weight-bold" style="color: #843f92">s.</span>
      &nbsp; <br />
      <v-tooltip bottom>
        <template v-slot:activator="{ attrs }">
          <v-btn
            v-bind="attrs"
            to="items/new"
            class="ma-2 font-weight-bold"
            slot="activator"
            rounded
            color="secondary"
            outlined
          >
            Add New listing
            <!-- <v-icon small class="mt-0.5">add</v-icon> -->
          </v-btn>
        </template>

        <span>Add another listing</span>
      </v-tooltip>
    </h4>

    <v-row v-if="item.userID == user.uid">
      <v-col
        v-for="item in items"
        :key="item.id"
        cols="12"
        lg="4"
        xl="4"
        sm="6"
        md="4"
      >
        <!-- <v-row :key="item.id" class="mb-2"> -->
        <v-hover v-slot="{ hover }">
          <v-card
            class="mr-12  itmcrd"
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
            :to="'/items/' + item.id"
            style="border-radius: 20px"
            rounding="8"
            outlined
            width="100%"
          >
            <v-container fluid>
              <v-row>
                <v-col cols="7" sm="4" md="3">
                  <v-card color="#f0f2f5" style="border-radius: 12px">
                    <v-img
                      :src="item.images ? item.images[0] : ''"
                      height="130px"
                    />
                  </v-card>
                </v-col>
                <v-col cols="7" sm="8" md="9">
                  <v-card-title primary-title>
                    <div>
                      <h5 class="black--text mb-0">
                        {{ item.itemName }}
                      </h5>

                      <div>R{{ item.dailyFee }} p/d</div>

                      <div :v-if="item.availabilty === true">
                        {{
                          item.availabilty == true
                            ? "Available "
                            : "Not Available"
                        }}
                      </div>
                    </div>
                  </v-card-title>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-hover>
        <!-- </v-row> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import firebase from 'firebase'

//const uuid = require('uuid')

export default {
  name: "Profile",
  components: {
    // Register: () => import('./Register.vue'),
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { "My-Awesome-Header": "header value" }
      },
      dialog: false,
      editPdialog: false,
      photo: "",
      userId: "",
      name: "",
      rating: 4,
      email: "",
      user: {},
      cards: ["Today", "Yesterday"],
      drawer: null
    };
  },

  computed: {
    items() {
      return this.$store.getters.loadedItems;
    }
  }
};
</script>

<style></style>
